import type { SxProps, Theme } from '@mui/material/styles'
import { TOP_NAV_HEIGHT_PX, muahangKiotLike } from '../../layout/muahangKiotTokens'

/** Chiều rộng modal theo viewport — ưu tiên tận dụng màn hình. */
export const FORM_MODAL_VIEWPORT_WIDTH = '90vw' as const

/**
 * Neo sát dưới thanh header menu — overlay/paper không che menu.
 * Trùng `TOP_NAV_HEIGHT_PX` (44px).
 */
export const FORM_MODAL_VIEWPORT_TOP_OFFSET_PX = TOP_NAV_HEIGHT_PX

/** Đệm dưới — tránh modal chạm mép bottom khi cao. */
export const FORM_MODAL_VIEWPORT_BOTTOM_BUFFER_PX = 10

/** Chiều cao tối đa modal (dưới header + đệm đáy). */
export const FORM_MODAL_VIEWPORT_MAX_HEIGHT =
  `calc(100dvh - ${FORM_MODAL_VIEWPORT_TOP_OFFSET_PX + FORM_MODAL_VIEWPORT_BOTTOM_BUFFER_PX}px)` as const

/** Overlay + backdrop bắt đầu dưới header — header vẫn hiện và bấm được. */
export const formModalBelowHeaderOverlaySx = {
  top: FORM_MODAL_VIEWPORT_TOP_OFFSET_PX,
} as const

type FormModalSizeEntry = {
  maxWidthPx: number
  widthCss?: string
}

/** Trần width (px) theo loại form — kết hợp với widthCss qua `maxWidth`. */
export const FORM_MODAL_SIZE: Readonly<Record<string, FormModalSizeEntry>> = {
  compact: { maxWidthPx: 520 },
  standard: { maxWidthPx: 960 },
  wide: { maxWidthPx: 1200 },
  xwide: { maxWidthPx: 1560 },
  xxwide: { maxWidthPx: 1800 },
  fullscreen: { maxWidthPx: 2560, widthCss: '98vw' },
}

export type FormModalSize = keyof typeof FORM_MODAL_SIZE

/** Khoảng cách grid trong modal. */
export const formModalGridSpacing = { xs: 1, sm: 1.25 } as const

/** Tiêu đề section gọn — dùng cho form nhiều trường trong modal. */
export const formModalSectionTitleCompactSx: SxProps<Theme> = {
  mt: 1.25,
  mb: 0.25,
  color: muahangKiotLike.kiotFormLabelColor,
  fontWeight: 600,
  fontSize: `${muahangKiotLike.kiotFormLabelFontSizePx}px`,
  fontFamily: muahangKiotLike.kiotFontStack,
  lineHeight: muahangKiotLike.kiotLineHeight,
  display: 'block',
  '&:first-of-type': { mt: 0 },
}

export const formGridColThird = { xs: 12, sm: 6, md: 4 } as const
export const formGridColHalf = { xs: 12, sm: 6 } as const
export const formGridColFull = { xs: 12 } as const

/** CSS width cho `BaseModal` — mặc định `90vw`, không vượt trần theo size. */
export function getFormModalWidthCss(size: FormModalSize = 'standard'): string {
  return FORM_MODAL_SIZE[size].widthCss ?? FORM_MODAL_VIEWPORT_WIDTH
}

export function getFormModalMaxWidthPx(size: FormModalSize): number {
  return FORM_MODAL_SIZE[size].maxWidthPx
}

export function getFormModalPaperMaxHeight(): string {
  return FORM_MODAL_VIEWPORT_MAX_HEIGHT
}
